import { Cessions, Pagination, Common } from '@factorin/domain';

import { withUrl, list, post } from '../rest';


interface CessionListRequest extends Pagination.Request {
    registerUid?: string;
    baseDateRange?: Common.DateRange;
    providerUid?: string;
    providerINN?: string;
    buyerUid?: string;
    buyerINN?: string;
    supplyAgreementNumber?: string;
    primaryDocumentDateRange?: Common.DateRange;
    amount?: Common.DecimalRange;
    cessionAmount?: Common.DecimalRange;
}

interface CedeRequest {
    registerUid: string;
    confirm: boolean;
    uids: string[];
}

const cessionsPart = withUrl('cessions');

export const cessions = {
    ...list<Cessions.Cession, CessionListRequest>(cessionsPart()),
    cede: post<CedeRequest, void>(
        ({ registerUid, confirm, uids }) => cessionsPart({
            query: {
                registerUid,
            },
            body: {
                Confirm: confirm,
                SupplyUids: uids,
            },
        }),
    ),
};
